// tslint:disable:no-any
// tslint:disable:jsx-no-string-ref

import React, { Component } from 'react';
import { Redirect } from 'react-router';
import Footer from '../components/Footer';
import CookieConsent from '../components/CookieConsent';
import Title from '../components/Title';
import PublicHeader from '../components/PublicHeader';

interface IUserAgreementState {
    height: number;
    scrollTo: any;
}

class UserAgreement extends Component<{}, IUserAgreementState> {
    constructor() {
        super({});
        this.state = {
            height: 600,
            scrollTo: null
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = 'WetNotes | User Agreement';
    }

    componentWillMount() {
        this.setState({
            height: window.innerHeight - 525
        });
    }

    scrollTo(refName: any) {
        this.setState({
            scrollTo: refName
        });
    }

    render() {
        return (
            <div className="user-agreement">
                <PublicHeader scrollTo={e => this.scrollTo(e)} />

                {this.state.scrollTo && (
                    <Redirect
                        to={{
                            pathname: '/',
                            state: {
                                scrollTo: this.state.scrollTo
                            }
                        }}
                    />
                )}

                <Title />

                <section style={{ minHeight: this.state.height }}>
                    <div className="wrapper">
                        <h1>User Agreement</h1>
                        <p>The text is being prepared...</p>
                    </div>
                </section>

                <Footer ref="footer" logged={false} />

                <CookieConsent />
            </div>
        );
    }
}

export default UserAgreement;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/UserAgreement.tsx